import "../style.css";

function OneStillComponent({ imagePath,  }) {
  return (
    <div
      className="fullscreen-image"
      style={{
        backgroundImage: `url(${imagePath})`,
        zIndex: 1,
      }}
    ></div>
  );
}

export default OneStillComponent;
